<template>
  <v-app>
    <div class="row all"  style="max-width: 100%;">
      <Menu ref="menu" />
      <div class="col all-col" id="app-content" ref="content">
        <Header />
        <Modal />
        <v-btn
          style="outline: none;"
          class="botton-top-app"
          fab
          dark
          fixed
          bottom
          right
          color="#981010"
            v-on:click="$refs.content.scrollTop = 0, $refs.content_mobile.scrollTop = 0, $root.$emit('all.scroll')"
        >
          <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
   <!-- v-if="getUser && getUser.role_id != 2" -->
        <template>
          <div class="row is-mobile full-with-r-button" style="height: 34px;" v-if="isButton">
            <div class="col col-in-r-button">
              <span class="text-r-button" v-on:click="$root.$emit('modal.applying') , isButton = false;">
                Срочная помощь адвоката
              </span>
              <span style="cursor: pointer" v-on:click="isButton = !isButton">
                X
              </span>
            </div>
          </div>
        </template>
        <!-- <template v-if="getUser && getUser.role_id == 2">
          <template v-if="getUser && !getUser.guid">
            <div class="full-with-r-button">
              <div class="col col-in-r-button" >
                <router-link to="/profile">
                  <span class="text-r-button">
                    Для отображения в списке адвокатов необходимо ввести платежные реквизиты
                  </span>
                </router-link>
              </div>
            </div>
          </template>
        </template> -->
        <div class="content-main" ref="content_mobile" id="app-content_mobile" >
          <!-- <Header /> -->
          <router-view class="" id="all_content" :key="$route.params.id" />
        </div>
        <Footer v-if="$route.meta.name != 'info'" />
       </div>
    </div>
  </v-app>
</template>

<script>
import { mapGetters  } from "vuex";
import Footer from "./footer";
import Header from "./header";
import Menu from './menu'
import Modal from "./modal.vue";

export default {
  data: () => ({
    isButton: true,
    ssr: false,
    size: "col-3",
    bar: 0,
    jq: '$',
    fab: false
  }),
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {
    toHelp(){
      this.$root.$emit('modal.applying');
    }
  },
  mounted() {
  },
  components: { Modal, Menu, Footer, Header}
};
</script>

<style scoped>
@import url("/static/fonts/Helvetica/stylesheet.css");

.full-with-r-button {
    /* position: absolute; */
    width: 100%;
    padding: 0;
    margin: 0;
    z-index: 100;
    color: #FFFFFF;
    background: #981010;
    /* height: 34px; */
    align-content: center;
    justify-content: center;
    border-radius: 20px;
    border-radius: 0;
}
.text-r-button{
  font-family: Gotham Pro;
  color: #FFFFFF;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
}
.col-in-r-button{
  display: flex;
  justify-content: space-between;
}
.all{
  padding: 0;
  margin: 0;
  background-color: #EBEBEB;
}
.red-button{
  border: none;
  background: #981010;
  border-radius: 36px;
  font-family: Gotham Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  text-align: center;
  color: #FFFFFF;
  padding: 0.5em 1em;
  outline: none !important;
}
.gey-button{
  border: none;
  background: #C4C4C4;
  border-radius: 36px;
  font-family: Gotham Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  text-align: center;
  color: #000000;
  padding: 0.5em;
  outline: none !important;
}
.all-col{
  padding: 0 !important;
  padding-left: 0;
  padding-right: 0;
  overflow: hidden;
}
.content-main{
  min-height: calc(100vh - 183px);
}
@media (max-width: 750px) {
  
  .botton-top-app{
    height: 35px;
    width: 35px;
    right: 10px;
    bottom: 59px
  }
  .is-desctop{
    display: none;
  }
  /* .content-and-footer{
    height: calc(100vh - 69px);
    overflow: auto;
    overflow-x: hidden;
  } */
}
 
@media (min-width: 750px) {
  .content-main{
    padding-left: 155px;
  }
  .is-mobile{
    display: none;
  }
  .all-col{
    height: 100vh;
    overflow-y: auto;
  }
} 
</style>



// WEBPACK FOOTER //
// App.vue?2f437fcf